export interface TierColorOption {
    token: string;
    bg: string;
    text: string;
}

export const tierColorOptions: TierColorOption[] = [
    { token: "gray", bg: "bg-gray-100", text: "text-gray-800" },
    { token: "blue", bg: "bg-blue-100", text: "text-blue-800" },
    { token: "green", bg: "bg-green-100", text: "text-green-800" },
    { token: "purple", bg: "bg-purple-100", text: "text-purple-800" },
    { token: "cyan", bg: "bg-cyan-100", text: "text-cyan-800" },
    { token: "teal", bg: "bg-teal-100", text: "text-teal-800" },
    { token: "emerald", bg: "bg-emerald-100", text: "text-emerald-800" },
    { token: "lime", bg: "bg-lime-100", text: "text-lime-800" },
    { token: "amber", bg: "bg-amber-100", text: "text-amber-800" },
    { token: "yellow", bg: "bg-yellow-100", text: "text-yellow-800" },
    { token: "orange", bg: "bg-orange-100", text: "text-orange-800" },
    { token: "fuchsia", bg: "bg-fuchsia-100", text: "text-fuchsia-800" },
    { token: "pink", bg: "bg-pink-100", text: "text-pink-800" },
    { token: "indigo", bg: "bg-indigo-100", text: "text-indigo-800" },
];

const fallback: TierColorOption = tierColorOptions[0];

export const tierColorForToken = (token: string | null): TierColorOption => {
    if (!token) {
        return fallback;
    }
    return tierColorOptions.find(o => o.token === token) ?? fallback;
};
